import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { forwardRef, useEffect, useRef, useState } from 'react'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import urls from '../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
import EditOperationForm from './EditOperationForm'
import EditIcon from '@mui/icons-material/Edit'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
export const PlanEntretien = () => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [loading, setLoading] = useState(false)
  const [types, setTypes] = useState([])
  const [selected, setSelected] = useState(false)
  const [selectedSupprimer, setSelectedSupprimer] = useState(false)
  const [typeDeBien, setTypeDeBien] = useState([])
  const [vehiculesTypes, setVehiculesTypes] = useState([])
  const [moterType, setMotortype] = useState([])

  const [immobiliers, setImmobiliers] = useState([])
  const [vehicules, setVehicules] = useState([])
  const [confirmDel, setConfirmDel] = useState(false)

  useEffect(() => {
    fetchOperations()
    fetchVehiclesTypes()
    fetchMotorTypes()
    fetchImmoFootPrint1()
  }, [])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudEntretienOperations}`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      // LAP-733 (GE022)
      alert(t('maintenance.alertSelectOne'))
    } else {
      // LAP-733 (GE022) — backend status code; kept untranslated on purpose
      const filteredOperations = operations.results.filter((v) => {
        if (selectedRows.indexOf(v.id) !== -1) {
          v.Statut = 'désactivé'
        }
        return v
      })
      setOperations({
        ...operations,
        results: filteredOperations,
        // count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkEntretienOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  const fetchImmobiliers = async () => {
    const url = urls.fetchAllImmobiliers
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterImmobiliers = []
      data.forEach((v) => {
        filterImmobiliers.push({ id: v.id, label: `${v.nom}` })
      })
      setImmobiliers([...filterImmobiliers])
    }
  }
  const fetchVehicules = async () => {
    const url = urls.fetchVehicles
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterVehicules = []
      data.forEach((v) => {
        filterVehicules.push({ id: v.id, label: `${v.Name}` })
      })
      setVehicules([...filterVehicules])
    }
  }

  const fetchVehiclesTypes = async () => {
    const url = urls.fetchVehiclesTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.vehicletype}`, id: v.id })
      })
      setVehiculesTypes([...filterTypes])
    }
  }

  const fetchImmoFootPrint1 = async () => {
    const url = '/api/domicile/get-immofootprint1/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const type_de_bien = []
      data.forEach((v) => {
        if (v.consumption_post === 'Type de bien')
          type_de_bien.push({ label: `${v.answer}`, id: v.id })
      })
      setTypeDeBien([...type_de_bien])
    }
  }
  const fetchMotorTypes = async () => {
    const url = urls.fetchMotorTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.motor_type}`, id: v.id })
      })
      setMotortype([...filterTypes])
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          {isMobile ? (
            <Box color={'white'} display={'flex'} gap={2}>
              <CreateOperationForm
                setOperations={setOperations}
                moterType={moterType}
                vehiculesTypes={vehiculesTypes}
                typeDeBien={typeDeBien}
              />
              <RemoveCircleIcon
                onClick={() => {
                  if (selectedRows.length === 0) {
                    /* LAP-733 (GE022) */ alert(t('maintenance.alertSelectOps'))
                  } else {
                    setConfirmDel(true)
                  }
                }}
              />

              <EditIcon
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('maintenance.alertSelectOneToEdit'))
                  }
                }}
              />
            </Box>
          ) : (
            <Box>
              <CreateOperationForm
                setOperations={setOperations}
                moterType={moterType}
                vehiculesTypes={vehiculesTypes}
                typeDeBien={typeDeBien}
              />
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 1) {
                    // formRef.current.handleClickOpen(true)
                    setSelectedRowsParams({
                      ...operations.results.filter((v) => v.id === selectedRows[0]),
                    })
                    setSelected(true)
                  } else {
                    setSelected(false)
                    /* LAP-733 (GE022) */ alert(t('maintenance.alertSelectOneToEdit'))
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('maintenance.btnEdit')}
              </CustomButton>

              {/* supprimer */}
              <CustomButton
                onClick={() => {
                  if (selectedRows.length === 0) {
                    /* LAP-733 (GE022) */ alert(t('maintenance.alertSelectOps'))
                  } else {
                    setConfirmDel(true)
                  }
                }}
              >
                {/* LAP-733 (GE022) */}
                {t('maintenance.btnDelete')}
              </CustomButton>
            </Box>
          )}
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
      {selected ? (
        <EditOperationForm
          setOperations={setOperations}
          setSelected={setSelected}
          params={selectedRowsParams}
          operations={operations}
          moterType={moterType}
          vehiculesTypes={vehiculesTypes}
          typeDeBien={typeDeBien}
          allvehicules={vehicules}
          allimmobiliers={immobiliers}
        />
      ) : (
        ''
      )}
      {confirmDel && <ConfirmDialog setOpen={setConfirmDel} handelYes={deleteBulkOperations} />}
    </>
  )
}

function ConfirmDialog({ setOpen, handelYes }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [openDialog, setOpenDialog] = useState(true)

  // const handleClickOpen = () => {
  //   setOpenDialog(true)
  // }

  const handleClose = () => {
    setOpenDialog(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {/* LAP-733 (GE022) */}
            {t('maintenance.confirmDeleteLinked')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose()
              handelYes()
            }}
          >
            {/* LAP-733 (GE022) */}
            {t('maintenance.btnYes')}
          </Button>
          {/* LAP-733 (GE022) */}
          <Button onClick={handleClose}>{t('maintenance.btnNo')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
